import { default as Header } from './Header';

export default Header;
